<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">

          <div class="modal-body">
            {{$store.state.modal_msg}}
          </div>

          <div class="btns">
            <div
              class="btn"
              @touchend="$store.commit('set_showModalDialog', false);"
            >
              キャンセル
            </div>
            <div
              class="btn"
              @touchend="do_yes()"
            >
              OK
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "Modal",
  methods: {
    do_yes() {
      this.$store.state.callback_func();
      this.$store.commit("set_showModalDialog", false);
    }
  }
};
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}
/* 画面上下真ん中に配置 */
.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}
/* ポップアップ外枠 */
.modal-container {
  width: 300px;
  margin: 0px auto;
  padding: 20px 15px;
  background-color: rgb(233, 233, 233);
  border-radius: 5px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
}
/* ボディ */
.modal-body {
  display: block;
  border: 0px;
  font-size: 0.9rem;
  color: black;
}
/* ボタン達 */
.btns {
  text-align: right;
}
/* ボタン */
.btn {
  display: inline-block;
  color: rgb(66, 133, 245);
  margin: 0 4px;
  font-size: 0.9rem;
}
.btn + .btn {
  font-weight: bold;
}

/*
* The following styles are auto-applied to elements with
* transition="modal" when their visibility is toggled
* by Vue.js.
*
* You can easily play with the modal transition by editing
* these styles.
*/

.modal-enter {
  opacity: 0;
}
.modal-leave-active {
  opacity: 0;
}
.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>
